import React from 'react';
import { Box, FormControlLabel, Checkbox, Typography } from '@mui/material';
import { BRAND } from '../../theme/brandTokens';

const LanguageSelector = ({ languageOptions, selectedLanguages, onLanguageChange }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, flexWrap: 'wrap' }}>
      {languageOptions.map((lang) => (
        <FormControlLabel
          key={lang.code}
          control={
            <Checkbox
              checked={selectedLanguages.includes(lang.code)}
              onChange={(e) => onLanguageChange(lang.code, e.target.checked)}
              sx={{
                color: BRAND.accentText,
                '&.Mui-checked': {
                  color: BRAND.accentText
                }
              }}
            />
          }
          label={
            <Typography 
              sx={{ 
                fontSize: { xs: '0.8rem', sm: '0.9rem' },
                fontWeight: { xs: 600, sm: 500 },
                color: BRAND.text
              }}
            >
              <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>
                {lang.code.toUpperCase()}
              </Box>
              <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                {lang.name}
              </Box>
            </Typography>
          }
        />
      ))}
    </Box>
  );
};

export default LanguageSelector;
